import cn from 'classnames';
import { useSelector } from 'react-redux';

import { Toggle } from 'components/FormComponents';

import { selectCompany } from 'api/company-slice';

import styles from './RolePermissionsTab.module.scss';

export const RolePermissionsTab = ({ role, register, permissions }) => {
  const company = useSelector(selectCompany);
  const visiblePermissions = (permissions || []).filter(
    permission =>
      !(
        company?.company_group_id &&
        !company?.is_company_group_parent &&
        permission.slug === 'billing:write'
      ),
  );

  return (
    <div className="u-padding background-secondary">
      <div className={cn('card', 'card-with-border')}>
        {visiblePermissions.map(permission => (
          <div key={permission.id} className={styles.permission}>
            <div>
              <p className="u-margin-bottom--tiny">{permission.name}</p>
              <p className="t-small u-margin-bottom--0">{permission.description}</p>
            </div>
            <Toggle
              disabled={role.locked}
              name={`permissions.${permission.id}`}
              tooltip={permission.description}
              register={register}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
